import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import BooksPage from './pages/BooksPage';
import SolverPage from './pages/SolverPage';
import BookSolverPage from './pages/BookSolverPage';
import CatalogPage from './pages/CatalogPage';
import PuzzlePage from './pages/PuzzlePage';
import PuzzleListPage from './pages/PuzzleListPage';
import StuckPage from './pages/StuckPage';


export default function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/books" element={<BooksPage />} />
                <Route path="/solver" element={<SolverPage />} />
                <Route path="/solver/:bookCode" element={<BookSolverPage />} />
                <Route path="/catalog" element={<CatalogPage />} />
                <Route path="/catalog/:typeSlug" element={<PuzzleListPage />} />
                <Route path="/play/:puzzleSlug" element={<PuzzlePage />} />
                <Route path="/stuck" element={<StuckPage />} />
            </Routes>
        </BrowserRouter>
    );
}
